module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0103.jpg?v=75b81aad";